import lang from "@/views/modules/Invitees/language/en";

export default {
    name: "new-invitee",
    components: {
    },
    data() {
        return {
            loading: true,
            invitee: {},
            lang:[],
        }
    },
    mounted() {
        this.getInvitees();
        this.lang = lang;
    },
    methods: {
        saveInvitee() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/invitees', self.invitee).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/invitees/' + response.data.invitee.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}